import {NodeSelection, Selection} from "prosemirror-state";

export const isNodeSelection = (selection: Selection): selection is NodeSelection =>
    'node' in selection;

